"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _i18nContext = _interopRequireDefault(require("../../__internal__/i18n-context"));

var _enGb = _interopRequireDefault(require("../../locales/en-gb"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const I18nProvider = ({
  locale,
  children
}) => locale ? /*#__PURE__*/_react.default.createElement(_i18nContext.default.Provider, {
  value: (0, _merge.default)({}, _enGb.default, locale)
}, children) : children;

I18nProvider.defaultProps = {
  locale: undefined
};
I18nProvider.propTypes = {
  locale: _propTypes.default.shape({
    locale: _propTypes.default.func,
    actions: _propTypes.default.shape({
      edit: _propTypes.default.func,
      delete: _propTypes.default.func,
      reset: _propTypes.default.func
    }),
    actionPopover: _propTypes.default.shape({
      ariaLabel: _propTypes.default.func
    }),
    actionToolbar: _propTypes.default.shape({
      selected: _propTypes.default.func
    }),
    batchSelection: _propTypes.default.shape({
      selected: _propTypes.default.func
    }),
    confirm: _propTypes.default.shape({
      no: _propTypes.default.func,
      yes: _propTypes.default.func
    }),
    date: _propTypes.default.shape({
      formats: _propTypes.default.shape({
        inputs: _propTypes.default.func,
        javascript: _propTypes.default.func
      })
    }),
    errors: _propTypes.default.shape({
      messages: _propTypes.default.shape({
        formSummary: _propTypes.default.func
      })
    }),
    message: _propTypes.default.shape({
      closeButtonAriaLabel: _propTypes.default.func
    }),
    numeralDate: _propTypes.default.shape({
      validation: _propTypes.default.shape({
        day: _propTypes.default.func,
        month: _propTypes.default.func,
        year: _propTypes.default.func
      })
    }),
    pager: _propTypes.default.shape({
      show: _propTypes.default.func,
      records: _propTypes.default.func,
      first: _propTypes.default.func,
      last: _propTypes.default.func,
      next: _propTypes.default.func,
      previous: _propTypes.default.func,
      pageX: _propTypes.default.func,
      ofY: _propTypes.default.func
    }),
    select: _propTypes.default.shape({
      actionButtonText: _propTypes.default.func,
      placeholder: _propTypes.default.func,
      noResultsForTerm: _propTypes.default.func
    }),
    switch: _propTypes.default.shape({
      on: _propTypes.default.func,
      off: _propTypes.default.func
    }),
    table: _propTypes.default.shape({
      noData: _propTypes.default.func
    }),
    textEditor: _propTypes.default.shape({
      tooltipMessages: _propTypes.default.shape({
        bold: _propTypes.default.func,
        italic: _propTypes.default.func,
        bulletList: _propTypes.default.func,
        numberList: _propTypes.default.func
      }),
      ariaLabels: _propTypes.default.shape({
        bold: _propTypes.default.func,
        italic: _propTypes.default.func,
        bulletList: _propTypes.default.func,
        numberList: _propTypes.default.func
      })
    }),
    titleSelect: _propTypes.default.shape({
      deselect: _propTypes.default.func
    }),
    wizards: _propTypes.default.shape({
      multiStep: _propTypes.default.shape({
        buttons: _propTypes.default.shape({
          submit: _propTypes.default.func,
          next: _propTypes.default.func,
          back: _propTypes.default.func
        })
      })
    })
  }),
  children: _propTypes.default.node.isRequired
};
var _default = I18nProvider;
exports.default = _default;